<nav class="navbar navbar-expand-lg navbar-light bg-light">
  <div class="container-fluid">
    <a class="navbar-brand" href="javascript:void(0)">Web Chat Settings</a>
    <div class="ms-auto d-flex gap-2 align-items-center flex-wrap justify-content-end">
      <button class="btn btn-sm btn-outline-success" (click)="openWaForm()">&#43; Web WhatsApp</button>
      <button class="btn btn-sm btn-outline-info" (click)="openTgForm()">&#43; Web Telegram</button>
    </div>
  </div>
</nav>
<hr />

<div class="container-fluid">
  <div class="alert alert-light border small">
    <strong>No VPS needed.</strong> These channels run directly on this server — scan a QR for Web WhatsApp,
    or log in with a Telegram user account for Web Telegram. Bot-token Telegram and other channels live under
    <a [routerLink]="['/lo', company_uuid, 'chat-channel']" class="alert-link">Chat Channels</a>.
  </div>
</div>

<!-- Web WhatsApp name form -->
<div class="container-fluid" *ngIf="showWaForm">
  <div class="card mb-3 border-success">
    <div class="card-body">
      <h6 class="card-title">Add Web WhatsApp</h6>
      <p class="text-muted small">Give the account a name, then scan the QR code with WhatsApp on your phone
        (Settings &rarr; Linked Devices &rarr; Link a Device).</p>
      <div class="row g-2 align-items-end">
        <div class="col-md-4">
          <label class="form-label">Name</label>
          <input type="text" class="form-control form-control-sm" [(ngModel)]="waName" placeholder="e.g. Support WhatsApp" />
        </div>
        <div class="col-md-8 d-flex gap-2">
          <button class="btn btn-sm btn-success" (click)="createWhatsApp()" [disabled]="waConnecting || !waName.trim()">
            {{ waConnecting ? 'Starting...' : 'Create & Show QR' }}
          </button>
          <button class="btn btn-sm btn-outline-secondary" (click)="cancelWaForm()">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Web WhatsApp QR panel -->
<div class="container-fluid" *ngIf="waChannelId">
  <div class="card mb-3 border-success">
    <div class="card-body text-center">
      <h6 class="card-title">Scan to connect WhatsApp</h6>
      <div *ngIf="waStatus === 'connected'" class="alert alert-success mb-2">Connected! You can close this.</div>
      <div *ngIf="waStatus !== 'connected'">
        <img *ngIf="waQrDataUrl" [src]="waQrDataUrl" alt="WhatsApp QR" class="img-fluid my-2" style="max-width:280px" />
        <div *ngIf="!waQrDataUrl" class="text-muted py-4">Waiting for QR code... (status: {{ waStatus }})</div>
        <p class="text-muted small mb-0">QR refreshes automatically. WhatsApp &rarr; Linked Devices &rarr; Link a Device.</p>
      </div>
      <button class="btn btn-sm btn-outline-secondary mt-2" (click)="closeQr()">Close</button>
    </div>
  </div>
</div>

<!-- Web Telegram auth form (multi-step) -->
<div class="container-fluid" *ngIf="showTgForm">
  <div class="card mb-3 border-info">
    <div class="card-body">
      <h6 class="card-title">Add Web Telegram (User Account)</h6>
      <p class="text-muted small">Login with a real Telegram account. Get API credentials from
        <a href="https://my.telegram.org" target="_blank">my.telegram.org</a>.</p>

      <!-- Step 1: API credentials -->
      <div *ngIf="!tgChannelId" class="row g-2 align-items-end">
        <div class="col-md-2">
          <label class="form-label">Name</label>
          <input type="text" class="form-control form-control-sm" [(ngModel)]="tgName" placeholder="Telegram Web" />
        </div>
        <div class="col-md-2">
          <label class="form-label">API ID</label>
          <input type="text" class="form-control form-control-sm" [(ngModel)]="tgApiId" placeholder="12345678" />
        </div>
        <div class="col-md-4">
          <label class="form-label">API Hash</label>
          <input type="text" class="form-control form-control-sm" [(ngModel)]="tgApiHash" placeholder="abc123def456..." />
        </div>
        <div class="col-md-4 d-flex gap-2">
          <button class="btn btn-sm btn-info" (click)="submitTgInit()" [disabled]="tgConnecting || !tgApiId.trim() || !tgApiHash.trim()">
            {{ tgConnecting ? 'Initializing...' : 'Next' }}
          </button>
          <button class="btn btn-sm btn-outline-secondary" (click)="cancelTgForm()">Cancel</button>
        </div>
      </div>

      <!-- Step 2: Phone -->
      <div *ngIf="tgChannelId && tgAuthState === 'awaiting_phone'" class="row g-2 align-items-end">
        <div class="col-md-5">
          <label class="form-label">Phone Number (with country code)</label>
          <input type="text" class="form-control form-control-sm" [(ngModel)]="tgPhone" placeholder="+60123456789" />
        </div>
        <div class="col-md-4 d-flex gap-2">
          <button class="btn btn-sm btn-info" (click)="submitTgPhone()" [disabled]="tgConnecting || !tgPhone.trim()">
            {{ tgConnecting ? 'Sending...' : 'Send Code' }}
          </button>
          <button class="btn btn-sm btn-outline-secondary" (click)="cancelTgForm()">Cancel</button>
        </div>
      </div>

      <!-- Step 3: Code -->
      <div *ngIf="tgChannelId && tgAuthState === 'awaiting_code'" class="row g-2 align-items-end">
        <div class="col-md-5">
          <label class="form-label">Auth Code (check your Telegram app)</label>
          <input type="text" class="form-control form-control-sm" [(ngModel)]="tgCode" placeholder="12345" autocomplete="off" />
        </div>
        <div class="col-md-4 d-flex gap-2">
          <button class="btn btn-sm btn-info" (click)="submitTgCode()" [disabled]="tgConnecting || !tgCode.trim()">
            {{ tgConnecting ? 'Verifying...' : 'Verify Code' }}
          </button>
          <button class="btn btn-sm btn-outline-secondary" (click)="cancelTgForm()">Cancel</button>
        </div>
      </div>

      <!-- Step 4: 2FA password -->
      <div *ngIf="tgChannelId && tgAuthState === 'awaiting_password'" class="row g-2 align-items-end">
        <div class="col-md-5">
          <label class="form-label">2FA Password</label>
          <input type="password" class="form-control form-control-sm" [(ngModel)]="tgPassword" placeholder="Your 2FA password" />
        </div>
        <div class="col-md-4 d-flex gap-2">
          <button class="btn btn-sm btn-info" (click)="submitTgPassword()" [disabled]="tgConnecting || !tgPassword.trim()">
            {{ tgConnecting ? 'Verifying...' : 'Submit' }}
          </button>
          <button class="btn btn-sm btn-outline-secondary" (click)="cancelTgForm()">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Channel list -->
<div class="container-fluid">
  <div class="text-center py-3" *ngIf="loading">Loading...</div>

  <div class="alert alert-info" *ngIf="!loading && channels.length === 0">
    No web channels yet. Click <strong>+ Web WhatsApp</strong> or <strong>+ Web Telegram</strong> to add one.
  </div>

  <div class="table-responsive" *ngIf="channels.length > 0">
    <table class="table table-bordered table-hover align-middle">
      <thead class="table-light">
        <tr>
          <th style="width:40px">#</th>
          <th>Channel</th>
          <th>Name</th>
          <th>Status</th>
          <th>Connection</th>
          <th>Created</th>
          <th style="width:230px">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let ch of channels; let i = index">
          <td>{{ i + 1 }}</td>
          <td>
            <span class="me-1">{{ channelIcon(ch.channel) }}</span>
            <span>{{ channelLabel(ch.channel) }}</span>
          </td>
          <td>
            <span *ngIf="editingId !== ch.id">{{ ch.name }}</span>
            <div class="d-flex align-items-center gap-1" *ngIf="editingId === ch.id">
              <input type="text" class="form-control form-control-sm" [(ngModel)]="editingName"
                (keydown.enter)="saveEdit(ch)" (keydown.escape)="cancelEdit()" style="max-width: 200px" />
              <button class="btn btn-sm btn-success px-2" (click)="saveEdit(ch)" title="Save">&#10003;</button>
              <button class="btn btn-sm btn-outline-secondary px-2" (click)="cancelEdit()" title="Cancel">&#10005;</button>
            </div>
          </td>
          <td>
            <span class="badge" [ngClass]="ch.status === 1 ? 'bg-success' : 'bg-secondary'">
              {{ ch.status === 1 ? 'Active' : 'Inactive' }}
            </span>
          </td>
          <td>
            <span class="badge" [ngClass]="getStatusBadgeClass(ch.connection_status)">{{ ch.connection_status }}</span>
          </td>
          <td>{{ ch.create_on | date:'dd-MM-yyyy HH:mm' }}</td>
          <td>
            <div class="d-flex gap-1 flex-wrap">
              <button class="btn btn-sm btn-outline-primary" (click)="startEdit(ch)" *ngIf="editingId !== ch.id" title="Edit name">&#9998;</button>

              <!-- WhatsApp: show QR / reconnect -->
              <button *ngIf="ch.channel === 'whatsapp' && ch.connection_status === 'qr_needed'"
                class="btn btn-sm btn-outline-success" (click)="openQr(ch.id)">Show QR</button>
              <button *ngIf="ch.channel === 'whatsapp' && ch.connection_status !== 'connected' && ch.connection_status !== 'qr_needed'"
                class="btn btn-sm btn-outline-success" (click)="reconnectWhatsApp(ch)">Connect</button>

              <!-- Telegram Web: reconnect -->
              <button *ngIf="ch.channel === 'telegram_web' && ch.connection_status !== 'connected'"
                class="btn btn-sm btn-outline-info" (click)="reconnectTg(ch)" [disabled]="tgConnecting">Connect</button>

              <!-- Disconnect -->
              <button *ngIf="ch.connection_status === 'connected'"
                class="btn btn-sm btn-outline-warning" (click)="disconnectChannel(ch)">Disconnect</button>

              <!-- Delete -->
              <button class="btn btn-sm btn-outline-danger" (click)="deleteChannel(ch)" title="Delete channel">&#128465;</button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
